import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QlfPlaceholder } from '@qualifio/ui-commons';
import { RewardAttributes } from '@loyalty/shared-common/rewards-api-client';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { useTranslation } from 'react-i18next';
import { QlfPlaceholderIcon } from '../../../shared/qlf-placeholder-icon/QlfPlaceholderIcon';
import { RewardsDetailsForm } from './RewardsDetailsForm';
import { rewardsIcon } from '../../../shared/icons';
import { useFeatures } from '../../../features/FeaturesContext';
import { useRewards } from '../../RewardsContext';

export function RewardsDetails(): React.ReactElement {
  const { t } = useTranslation();
  const { addReward, updateReward, selectedReward, rewards, createReward, isLoading } =
    useRewards();
  const { features } = useFeatures();
  const { write: rewardWrite } = features[Feature.REWARD];
  const loading = isLoading('updateReward') || isLoading('addReward');

  const handleSave = async (reward: RewardAttributes) => {
    if (reward?.createdAt) {
      updateReward(reward.id, reward);
    } else {
      addReward(reward);
    }
  };

  if (rewards.length === 0 || !selectedReward) {
    return (
      <QlfPlaceholder
        icon={<QlfPlaceholderIcon icon={rewardsIcon} />}
        primaryText={t('rewards.messages.no-items')}
        secondaryText={t('rewards.states.empty.description')}
        actions={
          <Tooltip
            title={rewardWrite ? '' : t('shared.action.permission.required')}
            placement="left"
          >
            <div>
              <Button
                disabled={!rewardWrite}
                color="primary"
                startIcon={<FontAwesomeIcon icon={faPlus} />}
                onClick={() => createReward()}
                style={{ marginTop: '20px' }}
                id={'create-reward-id'}
              >
                {t('rewards.states.empty.create-action')}
              </Button>
            </div>
          </Tooltip>
        }
      />
    );
  }
  return (
    <RewardsDetailsForm
      key={selectedReward?.id}
      reward={selectedReward}
      onSubmit={handleSave}
      isLoading={loading}
    />
  );
}
